import Grid from "@mui/material/Grid";
import { CajasProvider } from "../../../context/CajasContext/CajasContext";
import { InformeMovimientosList } from "../components/InformeMovimientosList";
import { PageHeaderCard } from "src/general_components/PageHeaderCard";
import HistoryIcon from "@mui/icons-material/History";

export function InformeMovimientos() {
  return (
    <Grid style={{ marginBottom: "50px", paddingTop: 10 }}>
      <PageHeaderCard title="Listado de Movimientos" icon={<HistoryIcon />} />
      <CajasProvider>
        <InformeMovimientosList />
      </CajasProvider>
    </Grid>
  );
}
